module.exports = __webpack_public_path__ + "static/media/Rectangle 1016.35dc9fc2.png";